export type PersonType = typeof PersonTypes[number];
export const PersonTypes = [
    'FacilityOwner',
    'SafetyInspector'
] as const;


export class Person{

    constructor(
        public id:string,
        public type: PersonType,
        public name:string,
        public role:string,
        public email:string,
        public phone:string
    ){}
}